/**
 * Parse a backend-issued naive-UTC ISO timestamp into a `Date`. Strings without
 * a timezone offset are treated as UTC: the backend stores several timestamps
 * (annotation `created`, acquisition `captured`, …) as naive UTC and serializes
 * them with no offset, which JS would otherwise parse as local time. Values that
 * already carry an offset (`Z` or `±HH:MM`) are respected as-is.
 *
 * Kept in its own leaf module so both `@/lib/utils` and `@/app/types/annotation`
 * can import it without a barrel cycle.
 */
export const parseNaiveUtcTimestamp = (value?: string | null): Date => {
  if (!value) return new Date(0)
  // Python's `datetime.isoformat()` emits `+HH:MM`, never `+HHMM`. The `:?`
  // tolerates the compact form for forward compatibility.
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value)
  return new Date(hasTimezone ? value : `${value}Z`)
}

/**
 * Backwards-compatible alias for annotation call sites. Prefer
 * {@link parseNaiveUtcTimestamp} — the parsing is not annotation-specific.
 */
export const parseAnnotationTimestamp = parseNaiveUtcTimestamp
